import { observable, action } from 'mobx';

export const FMSModalState: FMSModalStateShape = observable({
  bust: null,
  cup: null,
  sizeResult: null,
});

export const setBustFromUsersInput = action((value: string) => {
  FMSModalState.bust = value;
});

export const setCupFromUsersInput = action((value: string) => {
  FMSModalState.cup = value;
});

export const setSizeResult = action((value: string) => {
  FMSModalState.sizeResult = value;
});

export interface FMSModalStateShape {
  bust: string | null;
  cup: string | null;
  sizeResult: string | null;
}
